// import Swiper JS
import Swiper, { Autoplay, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css'; // optional for styling

// configure Swiper to use modules
Swiper.use([Autoplay, Pagination]);

export function initTallSlider() {
  if (window.acf) {
    window.acf.addAction(
      'render_block_preview/type=card-tall-carousel',
      verticalSlider
    );
  }
}

export function tallSlider() {
  if (!document.querySelector('.tall-slider')) return;

  var slideCount = document.querySelectorAll('.tall-carousel-slide').length;

  const swiperTall = new Swiper('.tall-slider .swiper', {
    // Optional parameters
    direction: 'horizontal',
    autoplay: {
      delay: 7000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    speed: 500,
    slidesPerView: 1,
    slidesPerGroup: 1,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        loop: slideCount > 1,
      },
      // when window width is >= 640px
      968: {
        slidesPerView: 2,
        loop: slideCount > 2,
      },
      1024: {
        slidesPerView: 2,
        loop: slideCount > 2,
      },
      1280: {
        slidesPerView: 3,
        loop: slideCount > 3,
      },
    },
    spaceBetween: 32,
    grabCursor: true,
    keyboardControl: true,
    centeredSlides: false,
    pagination: false,
    navigation: {
      nextEl: '.swiper-button-next-slide',
      prevEl: '.swiper-button-previous',
    },
    on: {
      slideChangeTransitionEnd: function () {
        tippy('[data-tippy-content]', {
          theme: 'maxcontact',
        });
      },
      afterInit: function () {
        tippy('[data-tippy-content]', {
          theme: 'maxcontact',
        });
      },
    },
  });
}
